import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import { compose } from "redux";
import { useFirestore } from "react-redux-firebase";
import PageLoader from "../../layout/PageLoader";

const useStyles = makeStyles(theme => ({
  root: {},
  form: {
    justifyContent: "center",
    textAlign: "center",
    margin: "0 auto",
    padding: 10
  },
  loading: {
    color: theme.palette.text.primary,
    margin: 0
  },
  pageLoaderWrapper: {
    marginTop: -350
  }
}));

const Checkout = props => {
  const classes = useStyles();
  const firestore = useFirestore();

  const [showLoaderMessage, setShowLoaderMessage] = useState(false);
  let logs = [];

  useEffect(() => {}, [showLoaderMessage]);

  const handleSubmit = e => {
    e.preventDefault();

    var yoco = new window.YocoSDK({
      publicKey: "pk_test_69eb7ec97y34Xo98f174"
    });

    const costInCents = props.totalCost * 100;

    yoco.showPopup({
      amountInCents: costInCents,
      currency: "ZAR",
      name: "Durban Comics",
      description: "Awesome description",
      callback: function(result) {
        // This function returns a token that your server can use to capture a payment
        if (result.error) {
          const errorMessage = result.error.message;
          alert("error occured: " + errorMessage);
        } else {
          // alert("card successfully tokenised: " + result.id);
          updateDatabase(result.id);
          //save result.id to the order as proof of payment
        }
      }
    });
  };

  const addOrder = (order, token) => {
    const currentDate = Date.now();
    let transactionLog = [];
    let paymentHistory = [];

    if (token) {
      setShowLoaderMessage(true);

      transactionLog.push({ date: currentDate, action: "order added" });
      transactionLog.push({ date: currentDate, action: "payment made" });
      paymentHistory = [{ payment: order.totalPaid, date: currentDate }];
      transactionLog.push({ date: currentDate, action: "payment complete" });

      firestore
        .collection("orders")
        .add({
          ...order,
          courierCompany: "",
          courierFee: 0,
          discount: 0,
          history: transactionLog,
          isCancelled: false,
          isComplete: false,
          isCouriered: false,
          isPaid: true,
          isWebsiteOrder: true,
          payments: paymentHistory,
          totalOwing: 0,
          trackingNumber: ""
        })
        .then(docRef => {
          firestore
            .collection("payments")
            .add({
              orderId: docRef.id,
              email: order.email,
              items: order.items,
              date: currentDate,
              payment: order.totalPaid,
              token: token
            })
            .then(() => {
              //console.log("payment added");
              let amount = order.totalPaid * 100;

              let url =
                "http://shopalpha.com/test.php?token=" +
                token +
                "&amount=" +
                amount;

              return fetch(url)
                .then(response => response.json())
                .then(responseData => {
                  setShowLoaderMessage(false);
                  console.log(responseData);
                  console.log("Success Redirect to confirmation screen");
                  //// redirect to a confirmation screen

                  window.location = "../paymentSuccess";
                })
                .catch(err => {
                  setShowLoaderMessage(false);
                  console.log("Failure Redirect to error screen");
                  console.log(err);
                  window.location = "../paymentError";
                });
            })
            .catch(err => {
              console.log("error---- " + err);
            });
        })
        .catch(err => {
          console.log("error---- " + err);
        });
    }
  };

  const updateInventory = products => {
    const currentDate = Date.now();
    products.forEach(item => {
      firestore
        .collection("inventory")
        .where("name", "==", item.name)
        .get()
        .then(snapshot => {
          snapshot.docs.forEach(product => {
            let inventoryItem = { ...product.data(), ["id"]: product.id };

            inventoryItem.amountAvailable =
              inventoryItem.amountAvailable - item.count;

            logs = inventoryItem.logs || [];
            logs.push({
              currentDate: currentDate,
              action: "sold",
              amount: item.count,
              amountAvailable: inventoryItem.amountAvailable
            });

            firestore
              .collection("inventory")
              .doc(product.id)
              .update({
                amountAvailable: inventoryItem.amountAvailable,
                logs: logs
              })
              .catch(err => {
                console.log("error" + err);
              });
          });
        })
        .catch(err => {
          console.log("error" + err);
        });
    });
  };
  const updateDatabase = token => {
    let orderForm = props.cartItems;
    let checkoutBasket = [];
    let updatedInventory = [];
    orderForm.forEach(item => {
      let count = item.count;
      updatedInventory.push({ name: item.name, count: item.count });
      for (var i = 0; i < count; i++) {
        checkoutBasket.push({ name: item.name, price: item.price });
      }
    });

    updateInventory(updatedInventory);
    addOrder(
      {
        email: props.auth.email,
        items: updatedInventory,
        totalCost: props.totalCost,
        totalPaid: props.totalCost
      },
      token
    );
  };

  return (
    <div className={classes.root}>
      <form id="addOrderForm" className={classes.form} onSubmit={handleSubmit}>
        {!showLoaderMessage ? (
          <Button
            className={classes.proceed}
            variant="contained"
            style={{
              textTransform: "none",
              backgroundColor: "#cc2b33",
              color: "white"
            }}
            type="submit"
          >
            Proceed to checkout
          </Button>
        ) : null}

        {showLoaderMessage ? (
          <div className={classes.loading}>
            Validating payment. Please Wait....
            <div className={classes.pageLoaderWrapper}>
              <PageLoader />
            </div>
          </div>
        ) : null}
      </form>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    inventory: state.firebase.inventory,
    orders: state.firebase.orders
  };
};

export default compose(connect(mapStateToProps))(Checkout);
